<template>
    <v-container>
      <div class="mb-5">
        <material-card color="primary" title="Tambah Pengaturan Eksternal" class="card-wrapper">
          <v-form>
            <v-row>
              <div class="form-input mt-5 mb-3">
                <p style="color: red">* Wajib Diisi</p>
              </div>
            </v-row>
            <v-row>
               
              <v-col cols="12" md="12">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Nama<span style="color: red">*</span></p>
                  <v-text-field 
                    dense
                    placeholder="Nama" 
                    required
                    outlined
                    v-model="formData.nama"
                    @input="$v.formData.nama.$touch()"
                    @blur="$v.formData.nama.$touch()"
                    :error-messages="namaErrors"
                  />
                </div>
              </v-col>
              <span style="color:red;">{{errorMessageNama}}</span>
              <v-col cols="12" md="12">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Secret Key<span style="color: red">*</span></p>
                  <v-text-field 
                    dense
                    placeholder="Secret Key"
                    required
                    outlined
                    v-model="formData.secretkey"
                    @input="$v.formData.secretkey.$touch()"
                    @blur="$v.formData.secretkey.$touch()"
                    :error-messages="secretkeyErrors"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="12">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">CallBack<span style="color: red">*</span></p>
                  <v-text-field 
                    dense
                    placeholder="CallBack" 
                    outlined
                    v-model="formData.callback"
                    @input="$v.formData.callback.$touch()"
                    @blur="$v.formData.callback.$touch()"
                    :error-messages="callbackErrors"
                  />
                </div>
                <p v-if="errorMessageCallback" style="color:red;">{{errorMessage}}</p>
              </v-col>
              <v-col cols="12" md="12">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Daftar Whitelist IP<span style="color: red">*</span></p>
                  <p><i>Pisahkan menggunakan tanda koma<b>(,)</b></i></p>
                  <v-textarea
                    dense
                    placeholder="Whitelist IP"
                    required
                    outlined
                    v-model="formData.whitelist_ip"
                    @input="$v.formData.whitelist_ip.$touch()"
                    @blur="$v.formData.whitelist_ip.$touch()"
                    :error-messages="whitelistErrors"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="12">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Daftar AuthConfig</p>
                  <v-textarea
                    dense
                    placeholder="AuthConfig"
                    outlined
                    v-model="formData.auth_config"
                    @input="$v.formData.authConfig.$touch()"
                    @blur="$v.formData.authConfig.$touch()"
                    :error-messages="authConfigErrors"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="12">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Daftar Header Config</p>
                  <v-textarea
                    dense
                    placeholder="Header Config"
                    outlined
                    v-model="formData.header_config"
                    @input="$v.formData.header_config.$touch()"
                    @blur="$v.formData.header_config.$touch()"
                    :error-messages="header_configErrors"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="12">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Daftar Body Config</p>
                  <v-textarea
                    dense
                    placeholder="Body Config"
                    outlined
                    v-model="formData.body_config"
                    @input="$v.formData.body_config.$touch()"
                    @blur="$v.formData.body_config.$touch()"
                    :error-messages="body_configErrors"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="12">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Keterangan<span style="color: red">*</span></p>
                  <v-textarea
                    dense
                    placeholder="Keterangan"
                    required
                    outlined
                    v-model="formData.keterangan"
                    @input="$v.formData.keterangan.$touch()"
                    @blur="$v.formData.keterangan.$touch()"
                    :error-messages="keteranganErrors"
                  />
                </div>
              </v-col>
             
              <v-col cols="12" class="text-right">
                <v-btn color="gray" dark @click="cancel()">Batal</v-btn>&nbsp;
                <v-btn color="primary" dark @click="postData()">Simpan</v-btn>&nbsp;
              </v-col>
            </v-row>
          </v-form>
        </material-card>
      </div>

    </v-container>
  </template>
  
<script>
  import { apiServer } from "../../setup-axios";
  import { minLength, maxLength, helpers, required } from "vuelidate/lib/validators";

  const textregex = helpers.regex('textregex', /^[a-zA-Z0-9 .,'()&\/-]{1,255}$/i);
  const isJsonString = (str) => {
    if (str === '') return true;
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  };
  export default {
    data: () => ({
      errorMessageNama: "",
      formData: {
        nama:"",
        secretkey:"",
        callback:"",
        whitelist_ip:"",
        auth_config:"",
        header_config:"",
        body_config:"",
        keterangan:"",
      },
    }),
    validations: {
      formData: {
        nama: {
          required,
          textregex,
          minLength: minLength(3),
          maxLength: maxLength(255)
        },
        secretkey: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(255)
        },
        callback: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(255)
        },
        whitelist_ip: {
          required,
          validIP: value => {
            if (!value) return false;
            const ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/; 
            const ipv4Regex = /^((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)\.?\b){4}$/
            const ips = value.split(',');
            console.log(ips)
            for (let ip of ips) {
              console.log(ip)
              if (!ipv6Regex.test(ip.trim()) && !ipv4Regex.test(ip.trim())) {
                console.log("false")
                return false
              }
            }
            return true
          },
        },
        auth_config: {
          minLength: minLength(3),
          isJsonString
        },
        header_config: {
          minLength: minLength(3),
          isJsonString
        },
        body_config: {
          minLength: minLength(3),
          isJsonString
        },
        keterangan: {
          required,
          minLength: minLength(3),
        },
      }
    },
    computed: {
      filteredOrganisasi(){
          return this.organisasis.filter(item => item.status)
      },
      namaErrors() {
        const errors = [];
        if (!this.$v.formData.nama.$dirty) return errors;
        !this.$v.formData.nama.required &&
        errors.push("Nama harus diisi");
        !this.$v.formData.nama.minLength &&
        errors.push("Nama maksimal 255 karakter");
        !this.$v.formData.nama.textregex &&
        errors.push("Nama hanya boleh mengandung huruf, angka, spasi, dan tanda . , ' ( ) & / -");
        
        return errors;
      },
      secretkeyErrors() {
        const errors = [];
        if (!this.$v.formData.secretkey.$dirty) return errors;
        !this.$v.formData.secretkey.required &&
        errors.push("SecretKey harus diisi");
        // errors.push("SecretKey hanya boleh mengandung huruf dan angka");
        
        return errors;
      },
      callbackErrors() {
        const errors = [];
        if (!this.$v.formData.callback.$dirty) return errors;
        !this.$v.formData.callback.required &&
        errors.push("Callback harus diisi");
        !this.$v.formData.callback.maxLength &&
        errors.push("Callback maksimal 255 karakter");
        return errors;
      },
      whitelistErrors() {
        const errors = [];
        if (!this.$v.formData.whitelist_ip.$dirty) return errors;
        !this.$v.formData.whitelist_ip.required &&
        errors.push("Whitelist harus diisi");
        !this.$v.formData.whitelist_ip.validIP &&
        errors.push("Format IP salah, harap diperbaiki sesuai format berikut: xxx.xxx.xxx.xxx,yyy.yyy.yyy.yyy,abcd:abcd:abcd:abcd, dst.");
        return errors;
      },
      auth_configErrors() {
        const errors = [];
        if (!this.$v.formData.auth_config.$dirty) return errors;
        !this.$v.formData.auth_config.minLength && errors.push("Auth Config minimal 3 karakter");
        !this.$v.formData.auth_config.isJsonString && errors.push("Auth Config harus berupa string JSON yang valid");
        return errors;
      },
      header_configErrors() {
        const errors = [];
        if (!this.$v.formData.header_config.$dirty) return errors;
        !this.$v.formData.header_config.minLength && errors.push("Header Config minimal 3 karakter");
        !this.$v.formData.header_config.isJsonString && errors.push("Header Config harus berupa string JSON yang valid");
        return errors;
      },
      body_configErrors() {
        const errors = [];
        if (!this.$v.formData.body_config.$dirty) return errors;
        !this.$v.formData.body_config.minLength && errors.push("Body Config minimal 3 karakter");
        !this.$v.formData.body_config.isJsonString && errors.push("Body Config harus berupa string JSON yang valid");
        return errors;
      },
      keteranganErrors() {
        const errors = [];
        if (!this.$v.formData.keterangan.$dirty) return errors;
        !this.$v.formData.keterangan.required &&
        errors.push("Keterangan harus diisi");
        !this.$v.formData.keterangan.maxLength &&
        errors.push("Keterangan maksimal 255 karakter");
        return errors;
      },
    },
    created() {
      console.log("loading pengaturan eksternal");
    //   this.getOrganisasi();
    //   this.getListPeran();
    },
    methods: {
      postData() {
        this.$v.$touch()
        if (this.$v.$anyError) {
          return
        }
        this.formData.nama = this.formData.nama.trim(" ")
        this.formData.secretkey = this.formData.secretkey.trim(" ")
        this.formData.callback = this.formData.callback.trim(" ")
        this.formData.whitelist_ip = this.formData.whitelist_ip.replace(/\n/g, ",").replace(/\r/g, "").replace(/ /g, "");
        this.formData.auth_config = this.formData.auth_config.trim(" ")
        this.formData.header_config = this.formData.header_config.trim(" ")
        this.formData.body_config = this.formData.body_config.trim(" ")
        this.formData.keterangan = this.formData.keterangan.trim(" ")
        console.log(JSON.stringify(this.formData))
       
        apiServer
            .post("/pengaturan-eksternal/create",this.formData)
            .then(response => {
              console.log("Successfully created pengaturan eksternal:")
              console.log(response.data.data)
              this.sendSnackbar("orange", "Pengaturan Eksternal  "+ this.formData.nama +" berhasil dibuat");
              // localStorage.setItem('createSuccess', "Pengaturan ekternal " + this.formData.nama + " berhasil dibuat.")
              this.$router.push("/pengaturan-eksternal")})
            .catch(error => {
              console.log("There was an error:", error.response); // Logs out the error
              this.errorMessageNama = error.response.data.message
            //   if (error.response.data.message.includes("Nama")) {
            //     this.errorMessage = error.response.data.message
            //     this.errorMessageUserNama = true
            //   } else if (error.response.data.message.includes("SecretKey")) {
            //     this.errorMessage = error.response.data.message
            //     this.errorMessageSecretkey = true
            //   } else if (error.response.data.message.includes("CallBack")) {
            //     this.errorMessage = error.response.data.message
            //     this.errorMessageCallback = true
            //   } else {
            //     console.log(error.response)
            //     this.errorMessage = "Kesalahan pada Server. Silakan hubungi Administrator"
            //     this.errorMessageUserName = true
            //   }
            });
      },
    //   getOrganisasi() {
    //     this.isLoading = true;
    //     apiServer
    //         .get("/penggunaeksternal/all")
    //         .then(response => {
    //           this.organisasis = response.data.data;
    //           console.log("search pengguna eksternal loaded")
    //           console.log(this.organisasis)
    //         })
    //         .catch(error => {
    //           console.log("There was an error:", error.response); // Logs out the error
    //           this.isLoading = false;
    //         });
    //   },
      cancel() {
        this.$router.push('/pengaturan-eksternal')
      },
      sendSnackbar(color, message) {
        this.$store.dispatch('setSnackbar', {
          snackbarColor: color,
          snackbarText: message,
        })
      },
      showSnackbar(color, message) {
        console.log("snack " + color + " - " + message);
        this.snackbar = true;
        this.snackbarText = message;
        this.snackbarColor = color;
      },
    }
  }
</script>
  